import React from "react";
import Central from './components/Central'

const App = () => {
  return (
    <>
      <Central></Central>
    </>
  );
};

export default App;
